module.exports = __webpack_public_path__ + "img/2.64d4bfe4.png";